<template>
<div>
    <div v-if="loading" class="my-loading"><i class="el-icon-loading"></i></div>
    <div v-else>
        <div class="ch-titls relative">
            <b>{{title}}</b>
            <div class="filter-dicc">
                <el-select v-model="filter.time_type" placeholder="起始时间" size="mini" class="w130" clearable @clear="getChartData" @change="getChartData">
                    <el-option v-for="item in time_options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
                <el-select v-model="filter.platform" placeholder="应用类型" size="mini" class="w130" clearable @clear="getChartData" @change="getChartData">
                    <el-option v-for="item in platform_options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </div>
        </div>
        <div id="index-echat" class="echart-one"></div>
    </div>   
</div>
</template>
<script>
import Echarts from '@/library/echarts/echarts'
export default {
    computed:{
        title(){
            return '应用统计'
        },
    },
    data(){
        return {
            show:true,
            loading:false,
            filter:{
                platform:'',
                time_type:'',
            },
            platform_options:[
                {value:1,label:'微信'},
                {value:2,label:'支付宝'},
                {value:3,label:'字节'},
            ],
            time_options:[
                {value:'week',label:'本周'},
                {value:'month',label:'本月'},
                {value:'last_month',label:'上个月'},
                {value:'near_month_1',label:'最近1个月'},
                {value:'near_month_3',label:'最近3个月'},
                {value:'near_month_6',label:'最近6个月'},
            ],
        }
    },
    methods:{
        getChartData(){
            this.loading = true;
            this.$http.post('/v1/pri/onboard/get-chart-data', this.filter)
            .then( (response) => {
                this.loading = false;
                var res = response.data;
                if (res.code == 1) {
                    setTimeout(()=>{
                        this.initChart(res.data)
                    }, 1000)
                }
            })
        },
        initChart(data){
            if (data.chart_type == 'bartickalign') {
                //柱状图
                var x_arr = this.getFieldInList(data.list, 'name');
                var y_arr = this.getFieldInList(data.list, 'count');
                var name = data.hasOwnProperty('name') ? data.name : '数量'
                const obj = {
                    title :'',
                    X : {
                        name:data.name,
                        arr:x_arr,
                    },
                    Y : {
                        name:name,
                        arr:y_arr,
                    }
                }
                Echarts.show('index-echat', data.chart_type, obj );
            } else if (data.chart_type == 'linesmooth_n') {
                //曲线图
                const obj = {
                    title :'',
                    legend:data.legend,
                    X : {
                        name:'应用',
                        arr:data.x,
                    },
                    Y : {
                        name:'数量',
                        arr:data.y,
                    }
                }
                Echarts.show('index-echat', data.chart_type, obj );
            }
        },
    },
    mounted(){
        this.getChartData();
    },
}
</script>
<style scoped>
.ch-titls{margin-bottom:32px;}
.ch-titls .filter-dicc{position: absolute;right: 20px;top: 0;}
</style>


// WEBPACK FOOTER //
// src/pages/index/_chart.vue